import { apiClient } from './api';
import { SupportTicket } from '../types';

class SupportService {
  async createSupportTicket(data: {
    subject: string;
    description: string;
    priority?: string;
  }): Promise<SupportTicket> {
    return apiClient.post<SupportTicket>('/member/support-tickets', data);
  }

  async getSupportTickets(): Promise<SupportTicket[]> {
    return apiClient.get<SupportTicket[]>('/member/support-tickets');
  }

  // Admin methods
  async getAllTickets(): Promise<SupportTicket[]> {
    return apiClient.get<SupportTicket[]>('/admin/support-tickets');
  }

  async updateTicketStatus(id: string, status: string, resolution?: string): Promise<SupportTicket> {
    return apiClient.patch<SupportTicket>(`/admin/support-tickets/${id}`, { status, resolution });
  }
}

export const supportService = new SupportService();
